import "../../App.css";
import Button from "../../components/form/Button";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { registrationEndpoint } from "./services/RegistrationService";
import { googleLoginEndpoint } from "../Login/services/loginService";
import useCallApiAndLoad from "../../hooks/useCallApiAndLoad";
import { RegisterUser, RegisterUserForm } from "./models/RegistrationModel";
import { fetchResponseAdapter } from "../../adapters/fetchAdapter";
import { getAuthUserAdapter } from "../../adapters/userAdapter";
import { adoptLegacy, setAuth, getLastPath } from "../../helpers/authHelper";
import { mapApiCodeMessage } from "../Login/helpers/responseHelper";
import { loginAction } from "../../redux/features/auth";
import { useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
// assets
import logo from "../../assets/images/iso_logo.svg";
import banner from "../../assets/images/registerpropietario.jpg";
import banner2 from "../../assets/images/registerinquilino.jpg";
import { getRealmPath } from "../../helpers/realmHelpers";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// import { listToSelectOptionAdapter } from "../../adapters/listsAdapter";
// import {
//   getCountriesEndpoint,
//   getStatesEndpoint,
// } from "../../services/publicService";
import FormControlError from "../../components/Controls/FormControlError";
import MaskInput from "../../components/Controls/MaskInput";
import { useSelector } from "react-redux";
import { AppStore } from "../../redux/store";
import { IconLock, IconMail, IconPhone, IconUser, IconUsers } from "@tabler/icons-react";
import PhoneSelector from "../../components/Controls/PhoneSelector/PhoneSelector";
import { useGoogleLogin } from "@react-oauth/google";

interface Props {
  realm: string;
}

const Registration = (props: Props) => {
  const { country } = useSelector((state: AppStore) => state.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, callEndpoint } = useCallApiAndLoad();

  const [dialCode, setDialCode] = useState("");
  const [phoneLength, setPhoneLength] = useState(0);
  const [loginError, setLoginError] = useState("");
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const { realm } = props;
  // const [countries, setCountries] = useState<Array<any>>([]);
  // const [states, setStates] = useState<Array<any>>([]);
  let bannerRegistration;

  // Función común para procesar autenticación/registro exitoso con Google
  const processSuccessfulGoogleAuth = async (responseData: any) => {
    const authData = getAuthUserAdapter({
      first_name: responseData.name,
      access_token: responseData.access_token,
      refresh_token: responseData.refresh_token,
      realm: responseData.realm,
      avatar: responseData.avatar,
      name: responseData.name,
      last_name: responseData.last_name,
    });
    dispatch(loginAction(authData));
    setAuth(authData);
    await adoptLegacy(authData, country);
    const lpath = getLastPath();
    console.log("lpath, ommited google registration", lpath);
    window.open(`/app/${country}/l/opciones/mi-cuenta`, "_self");
  };

  // Función común para procesar errores de Google
  const processGoogleError = (data: any) => {
    const { code, message } = data;
    const messageDictionary = mapApiCodeMessage(code);
    console.log({ message, messageDictionary });
    setLoginError(`Error Google Registration (${code}): ${message || messageDictionary}`);
  };

  // Función para registro/login con Google usando el endpoint de login
  const doGoogleRegistration = async (googleAccessToken: string) => {
    setLoginError("");
    setIsGoogleLoading(true);
    try {
      const { status, data } = await callEndpoint(
        googleLoginEndpoint("customer", googleAccessToken, country)
      );
      if (status === 200) {
        const response = fetchResponseAdapter(data);
        const responseData = response.data;
        processSuccessfulGoogleAuth(responseData);
      } else {
        processGoogleError(data);
      }
    } catch (error) {
      console.error("Error en Google registration:", error);
      setLoginError("Error de conexión. Inténtalo de nuevo.");
    } finally {
      setIsGoogleLoading(false);
    }
  };

  // Función de login con Google
  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      console.log("Google Access Token:", codeResponse.access_token);
      // Llamar a la función de Google registration que usa el endpoint de login
      doGoogleRegistration(codeResponse.access_token);
    },
    onError: (error) => {
      console.log("Error en Google Login:", error);
      setLoginError("Error al autenticar con Google. Inténtalo de nuevo.");
    },
  });

  // Wrapper para manejar el click del botón
  const handleGoogleLogin = () => {
    googleLogin();
  };

  if (realm === "tenant") {
    bannerRegistration = banner2;
  } else {
    bannerRegistration = banner;
  }
  useEffect(() => {
    const callCatalogs = async () => {
      if (realm === "tenant") {
        bannerRegistration = banner2;
      } else {
        bannerRegistration = banner;
      }
      // if (realm !== "landlord") {
      //   return;
      // }
      // const { status, data } = await callEndpoint(getCountriesEndpoint());
      // if (status !== 200) {
      //   return;
      // }
      // const countriesData = fetchResponseAdapter(data);
      // setCountries(
      //   listToSelectOptionAdapter(
      //     countriesData.data,
      //     "country_id",
      //     "country_name"
      //   )
      // );
    };
    callCatalogs().catch((e) => console.error(e));
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<RegisterUserForm>({
    resolver: yupResolver(
      yup
        .object({
          name: yup.string().required("Nombre es requerido"),
          last_name: yup.string().required("Apellido es requerido"),
          email: yup
            .string()
            .email("Ingrese un formato correcto para correo")
            .required("Email es requerido"),
          password: yup.string().required("Contraseña es requerida"),
          confirm_password: yup
            .string()
            .required("Confirmación de Contraseña es requerida")
            .oneOf(
              [yup.ref("password"), null],
              "Contraseñas deben ser iguales"
            ),
          phone: yup
            .string()
            .required("El numero de teléfono es requerido")
            .length(
              phoneLength,
              `Debe contener exactamente ${phoneLength} dígitos`
            ),
          // ...(realm === "landlord"
          //   ? {
          //       country: yup.string().required("País es requerido"),
          //       state: yup.string().required("Departamento es requerido"),
          //     }
          //   : {}),
        })
        .required()
    ),
  });

  const doRegister = async (form: RegisterUserForm) => {
    const registration: RegisterUser = {
      username: form.email,
      password: form.password,
      first_name: form.name,
      last_name: form.last_name,
      email: form.email,
      phone: form.phone,
      area_code: dialCode,
      country: "",
      state: "",
    };
    const { status, data } = await callEndpoint(
      registrationEndpoint(realm, registration)
    );
    if (status === 200) {
      const response = fetchResponseAdapter(data);
      const responseData = response.data;
      const pathRealm = getRealmPath(realm);
      return navigate(
        `/app/${country}/auth/confirmation/${pathRealm}/${responseData.pid}`,
        {
          replace: true,
          state: { email: form.email },
        }
      );
    }
    const { code, message } = data;
    setLoginError(`Error(${code}): ${message}`);
  };

  useEffect(() => {
    let url = window.location.pathname;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          // setUbicacion(position?.coords);
          console.log({ position });
        },
        (error) => {
          console.error("Error al obtener la ubicación:", error);
        }
      );
    } else {
      console.error("La geolocalización no está disponible en este navegador.");
    }
  }, []);

  // const handleChangeCountry = async ({ target }: any) => {
  //   const { value = "" } = target;
  //   setStates([]);
  //   if (value) {
  //     const { status, data } = await callEndpoint(getStatesEndpoint(value));
  //     if (status === 200) {
  //       const statesResponse = fetchResponseAdapter(data);
  //       setStates(
  //         listToSelectOptionAdapter(
  //           statesResponse.data,
  //           "state_id",
  //           "state_name"
  //         )
  //       );
  //       return;
  //     }
  //   }
  // };

  return (
    <Fragment>
      <div className="flex flex-col h-auto lg:h-screen">
        <div className=" flex-1">
          <div className="flex md:flex-row flex-col-reverse h-full">
            <div className="flex flex-col md:w-1/2 justify-center items-center text-flat-dark-blue-500 bg-white">
              <div className="md:w-10/12 md:p-0 py-14 px-8">
                <h1 className="text-3xl lg:text-4xl font-bold">
                  ¡Hola, bienvenido!👋🏼
                </h1>
                <h2 className="font-semibold text-xl mt-4">
                  Con Propi puedes:
                </h2>
                <ul className=" space-y-12 mt-14 md:w-10/12">
                  <li className="flex space-x-10">
                    <img
                      className="w-20 h-20"
                      src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/quiero_comprar.svg"
                      alt=""
                    />
                    <div>
                      <p className="font-bold">Encontrar tu nuevo hogar</p>
                      <p className="mt-1 text-[#757575] text-sm leading-tight">
                        Descubre los mejores inmuebles para vivir o invertir.
                        ¡Te apoyamos a construir tu patrimonio!
                      </p>
                    </div>
                  </li>
                  <li className="flex space-x-10">
                    <img
                      className="w-20 h-20"
                      src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/quiero_alquilar.svg"
                      alt=""
                    />
                    <div>
                      <p className="font-bold">Vender mi propiedad</p>
                      <p className="mt-1 text-[#757575] text-sm leading-tight">
                        ¡Haz el proceso 100% digital! Selecciona tus propiedades
                        favoritas, programa tus visitas, oferta y negocia con el
                        propietario y firma el contrato digitalmente.
                      </p>
                    </div>
                  </li>
                  <li className="flex space-x-10">
                    <img
                      className="w-20 h-20"
                      src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/quiero_vender.svg"
                      alt=""
                    />
                    <div>
                      <p className="font-bold">
                        Alquilar mi propiedad y rental management
                      </p>
                      <p className="mt-1 text-[#757575] text-sm leading-tight">
                        ¡Despreocúpate de tu casa o apartamento! Nos encargamos
                        de rentabilizar tus inversiones alquilando al mejor
                        inquilino o vendiendo al mejor precio.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="bg-[#EBF1E8] drop-shadow-none md:w-1/2 flex flex-wrap px-4 py-8 md:py-0 md:px-0">
              <div className="w-full md:w-[400px] m-auto bg-white px-8 py-10 rounded-lg container-form">
                <div className="mb-4">
                  <a href={`/${country}`}>
                    <img
                      className=" mx-auto w-44"
                      src="https://storage.googleapis.com/assets-us-east4-propilatam/website-assets/propi-web/v2/logo-propi.svg"
                      alt=""
                    />
                  </a>
                </div>
                <p className="text-base text-[#757575] font-medium text-left leading-tight">
                  Para ofrecerte las mejores opciones para comprar o vender tu propiedad, necesitamos que completes los siguientes datos.
                </p>

                <br />

                <p className="text-base text-[#757575] font-medium text-left leading-tight">
                  Accede fácilmente con:
                </p>

                <div className="mt-4">
                  <Button
                    variant="outlined"
                    size="lg"
                    className="w-full bg-white hover:bg-gray-50 text-[#212121] border border-gray-300"
                    startIcon={
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                      </svg>
                    }
                    label="Registrarse con Google"
                    onClick={handleGoogleLogin}
                    disabled={isLoading || isGoogleLoading}
                  />
                </div>

                <div className="my-4 flex items-center">
                  <div className="flex-grow border-t border-gray-300"></div>
                  <span className="flex-shrink mx-4 text-sm text-gray-500">O completa el formulario</span>
                  <div className="flex-grow border-t border-gray-300"></div>
                </div>

                <form
                  id={
                    realm === "landlord"
                      ? "cuenta-creada-propietario"
                      : "cuenta-creada-inquilino"
                  }
                  onSubmit={handleSubmit(doRegister)}
                  className="login-form mt-3"
                >
                  <FormControlError message={loginError} />

                  <div className="relative input-icon">
                    <IconUser color="#BDBDBD" />
                    <input
                      type="text"
                      placeholder="Nombres"
                      className="w-full focus:outline-none mt-1 border border-grayForm rounded-md text-[#757575] py-2 px-2 pl-10 text-sm"
                      {...register("name")}
                    />
                  </div>

                  <FormControlError message={errors.name?.message} />

                  <div className="relative input-icon">
                    <IconUsers color="#BDBDBD" />
                    <input
                      type="text"
                      placeholder="Apellidos"
                      className="w-full focus:outline-none mt-1 border border-grayForm rounded-md text-graySoft py-2 px-2 pl-10 text-sm"
                      {...register("last_name")}
                    />
                  </div>

                  <FormControlError message={errors.last_name?.message} />

                  <div className="relative input-icon">
                    <IconMail color="#BDBDBD" />
                    <input
                      type="text"
                      placeholder="Email"
                      className="w-full focus:outline-none mt-1 border border-grayForm rounded-md text-graySoft py-2 px-2 pl-10 text-sm"
                      {...register("email")}
                    />
                  </div>

                  <FormControlError message={errors.email?.message} />
                  <div className="relative input-icon">
                    <IconLock color="#BDBDBD" />
                    <input
                      type="password"
                      placeholder="Contraseña"
                      className="w-full focus:outline-none mt-1 border border-grayForm rounded-md text-[#757575] py-2 px-2 pl-10 text-sm"
                      {...register("password")}
                    />
                  </div>

                  <FormControlError message={errors.password?.message} />

                  <div className="relative input-icon">
                    <IconLock color="#BDBDBD" />
                    <input
                      type="password"
                      placeholder="Confirmar contraseña"
                      className="w-full focus:outline-none mt-1 border border-grayForm rounded-md text-[#757575] py-2 px-2 pl-10 text-sm"
                      {...register("confirm_password")}
                    />
                  </div>
                  <FormControlError
                    message={errors.confirm_password?.message}
                  />
                  <PhoneSelector
                    name="phone"
                    control={control}
                    onCountryCodeChange={(code) => setDialCode(code)}
                    onCountryLengthChange={(length) => setPhoneLength(length)}
                  />
                  <FormControlError message={errors.phone?.message} />

                  <div className="my-6">
                    <Button
                      type="submit"
                      variant="contained"
                      size="lg"
                      className="w-full"
                      label="Crear cuenta"
                      loading={isLoading}
                    />
                  </div>
                  <div className="mt-2 text-center">
                    <span className="text-base text-[#757575] font-medium">
                      ¿Ya tienes una cuenta?{" "}
                    </span>
                    <Button
                      as="link"
                      href={`/app/${country}/auth/login`}
                      variant="transparent"
                      size="base"
                      className="!p-1 text-primary font-semibold text-base !inline-flex"
                      label="Iniciar sesión"
                      disabled={isLoading}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  );
};

export default Registration;
